import React from 'react';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';
import { InspectionChecklist } from '../common';

export const ProductSafetyCheckDetails: React.FC<DynamicComponentProps> = (props: DynamicComponentProps) => {
    return (
        <InspectionChecklist 
            {...props}
            defaultHeader="Product Safety Check Details"
            completionTranslationKey="product_safety_check_complete"
        />
    );
};